<template>
  <v-btn
    class="whatsapp-button"
    :href="`https://wa.me/${tel}?text=${text}`"
    fab
    target="_blank"
    color="#00E676"
    dark
    fixed
    bottom
    right
  >
    <v-icon>fab fa-whatsapp</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    tel: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
.whatsapp-button-text {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 17px;
  text-transform: none;
}
.whatsapp-button {
  z-index: 999;
}
</style>
